import {useEffect, useState} from "react";
import {getAll as getRecords} from "app/requests/admin/newsletters";
import {Loading} from "components/helpers";
import Row from "./row";

export default function AdminNewslettersList() {
  const [records, setRecords] = useState(null);
  const onDestroy = (uid) => {
    setRecords(records.filter((record) => record.uid !== uid));
  };

  useEffect(() => {
    getRecords().then((data) => setRecords(data.records));
  }, []);

  if(!records) { return <Loading />; }

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-md-10 offset-md-1">
          <h1 className="text-center">Newsletters</h1>
          <div className="row">
            <div className="col-12 text-right mb-1">
              <a className="btn btn-outline-secondary btn-sm" href="/admin/newsletters/new">New Newsletter</a>
            </div>
          </div>
          <div className="table-responsive rounded">
            <table className="table table-hover text-center">
              <thead className="thead-dark">
                <tr>
                  <th>Published</th>
                  <th>Subject</th>
                  <th>Created At</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {records.map((record) => (
                  <Row key={record.uid} onDestroy={onDestroy} record={record} />
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
